const inviteAddTenant = {
  toastr: 'Tenant Adicionado',
  toastr1: 'O tenant foi adicionado com sucesso',
  toastrError: 'Senha Incorreta'
};

export default inviteAddTenant;
